import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Tab } from '@mui/material';
import MyProfile from './my-profile/MyProfile';
import BankDetail from './bank-details/BankDetail';
import TaxInvoiceAndKyc from './tax-invoice-and-kyc/TaxInvoiceAndKyc';
import '../../../../styles/components/CreateEvent.css';
import '../../../../styles/components/Settings.css';

function Settings() {
    const { user } = useSelector((state) => state.auth);
    const [activeTab, setActiveTab] = useState('profile');
    return (
        <section id="event-creation-section">
            <div className="event-creation-stepper">
                <Tab
                    label="My Profile"
                    variant={activeTab === 'profile' ? 'main' : 'inactive'}
                    onClick={() => setActiveTab('profile')}
                />
                <Tab
                    label="Banking Details"
                    variant={activeTab === 'banking' ? 'main' : 'inactive'}
                    onClick={() => setActiveTab('banking')}
                />
                <Tab
                    label="Account Settings"
                    variant={activeTab === 'account' ? 'main' : 'inactive'}
                    onClick={() => setActiveTab('account')}
                />
                <Tab
                    label="Tax Invoice Details"
                    variant={activeTab === 'tax' ? 'main' : 'inactive'}
                    onClick={() => setActiveTab('tax')}
                    disabled={user?.verification === null}
                />
            </div>
            <div className="user-profile-tabs-content">
                {activeTab === 'profile' && <MyProfile />}
                {activeTab === 'banking' && <BankDetail />}
                {activeTab === 'account' && <div>Account Settings Content</div>}
                {activeTab === 'tax' && <TaxInvoiceAndKyc />}
            </div>
        </section>
    );
}

export default Settings;